export const popularDestinations = [
    9128, 9138, 9137, 9133, 10129, 9125, 9131, 10131, 9135, 9136, 10136, 10133,
    9782, 10094, 9134, 9129, 9132, 9124, 10095, 9127, 9126, 9123, 10134, 10137,
    10275, 10128, 9278, 9130, 10130, 9277, 10135, 10274, 9318, 10278, 10277,
    10132, 10096, 10276, 10279, 11789,
];
export const isPopularDestination = (id) => {
    const parsedId = Number(id);
    const parsedIdIsPopularDestination = popularDestinations.includes(parsedId);
    return parsedIdIsPopularDestination;
};
/**
 * Replace text in a string, by using '%s'
 * representing a variable.
 */
export const dynamicLabel = (text, word) => {
    return text.replace(/%s/g, word);
};
/**
 * Used to find errors in nested React Hook Form elemtns
 */
export const findNestedError = (errors, splitName, number = 0) => {
    // Check if the error object is empty and return early if empty.
    if (!errors || !Object.keys(errors).length)
        return;
    const hasMessage = errors.message;
    if (hasMessage) {
        return errors;
    }
    const nestedObject = errors[splitName[number]];
    return findNestedError(nestedObject, splitName, number + 1);
};
//# sourceMappingURL=form.utils.js.map